import React, { Component } from "react";

import moment from 'moment';

import WorkspaceChartHelper from "../Helper/WorkspaceChartHelper";
import WorkspaceTableChart from "./WorkspaceTableChart";
import WorkspaceDataManager from "../../managers/WorkspaceDataManager";
import { identity } from "underscore";

export default class WorkspaceCard extends Component {
	constructor(props) {
		super(props);

		this.chartHelper = new WorkspaceChartHelper();

		this.state = {
			shiftDown: false,
			ctrlDown: false,
			tableSortBy: {
				columnName: null,
				isDesc: false,
			},
			isLoading: true
		};

		if (jackDebug.workspaceCard === undefined) { jackDebug.workspaceCard = {} }
		jackDebug.workspaceCard = this;

		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleDesignBlur = this.handleDesignBlur.bind(this);
		this.handleDesignBlur = this.handleDesignBlur.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);

		this.setTableSortBy = this.setTableSortBy.bind(this);

		this.prepareData = this.prepareData.bind(this);
		this.filterData = this.filterData.bind(this);
		this.groupData = this.groupData.bind(this);
		this.getType = this.getType.bind(this);

		this.tableSortData = this.tableSortData.bind(this);

		this.generateBarChart = this.generateBarChart.bind(this);
		this.generateLineChart = this.generateLineChart.bind(this);
		this.generatePieChart = this.generatePieChart.bind(this);
		this.generateStackedBarChart = this.generateStackedBarChart.bind(this);
		this.generateCardChart = this.generateCardChart.bind(this);
		this.generateTable = this.generateTable.bind(this);

		this.generateContent = this.generateContent.bind(this);
		this.generateDesignFeatures = this.generateDesignFeatures.bind(this);

		this.generateMenu = this.generateMenu.bind(this);
	}

	componentDidUpdate() {
		if(this.props.cardLoading !== null) {
			if(this.props.cardLoading === this.props.identity.id && !this.state.isLoading) {
				this.setState({isLoading: true});
			}
		} else {
			if(this.props.identity.chartType === 'line') {
				if(this.state.isLoading !== this.props.longDataLoading) {
					this.setState({isLoading: this.props.longDataLoading});
				}
			} else {
				if(this.state.isLoading !== this.props.dataLoading[this.props.identity.dataSet]) {
					this.setState({isLoading: this.props.dataLoading[this.props.identity.dataSet]});
				}
			}
		}		
	}

	handleFocus(e) {
		if (this.props.isDesignMode) {
			this.handleDesignFocus(e);
		} else {
		}
	}

	handleBlur(e) {
		if (this.props.isDesignMode) {
			this.handleDesignBlur(e);
		} else {
		}
	}

	handleDesignFocus(e) {
		document.addEventListener("keydown", this.handleKeyDown);
		document.addEventListener("keyup", this.handleKeyUp);
	}

	handleDesignBlur(e) {
		document.removeEventListener("keydown", this.handleKeyDown);
		document.removeEventListener("keyup", this.handleKeyUp);
	}

	handleKeyDown(e) {
		e = e || window.event;
		e.preventDefault();

		let identity = this.props.identity;

		let keyActions = {
			38: {
				both: { check: "", action: "switchUp" },
				shft: { check: "canStretchUp", action: "stretchUp" },
				ctrl: { check: "canShrinkY", action: "shrinkUp" },
				none: { check: "canStretchUp", action: "moveUp" },
			},
			39: {
				both: { check: "", action: "switchRight" },
				shft: { check: "canStretchRight", action: "stretchRight" },
				ctrl: { check: "canShrinkX", action: "shrinkRight" },
				none: { check: "canStretchRight", action: "moveRight" },
			},
			40: {
				both: { check: "", action: "switchDown" },
				shft: { check: "canStretchDown", action: "stretchDown" },
				ctrl: { check: "canShrinkY", action: "shrinkDown" },
				none: { check: "canStretchDown", action: "moveDown" },
			},
			37: {
				both: { check: "", action: "switchLeft" },
				shft: { check: "canStretchLeft", action: "stretchLeft" },
				ctrl: { check: "canShrinkX", action: "shrinkLeft" },
				none: { check: "canStretchLeft", action: "moveLeft" },
			},
		};

		if (e.keyCode === 16 && !this.state.shiftDown) {
			this.setState({ shiftDown: true });
		} else if (e.keyCode === 17 && !this.state.ctrlDown) {
			this.setState({ ctrlDown: true });
		} else if ([37, 38, 39, 40].includes(e.keyCode)) {
			let ka = keyActions[e.keyCode];

			if (this.state.shiftDown && this.state.ctrlDown) {
				if (ka.both.check === "") {
					this.props[ka.both.action]();
				}
			} else if (this.state.shiftDown) {
				if (this.props[ka.shft.check]) {
					this.props[ka.shft.action]();
				}
			} else if (this.state.ctrlDown) {
				if (this.props[ka.ctrl.check]) {
					this.props[ka.ctrl.action]();
				}
			} else {
				if (this.props[ka.none.check]) {
					this.props[ka.none.action]();
				}
			}
		}
	}

	handleKeyUp(e) {
		e = e || window.event;
		e.preventDefault();

		if (e.keyCode === 16) {
			this.setState({ shiftDown: false });
		} else if (e.keyCode === 17) {
			this.setState({ ctrlDown: false });
		}
	}

	setTableSortBy(columnName) {
		let tableSortBy = this.state.tableSortBy;
		if (tableSortBy.columnName != columnName) {
			tableSortBy.columnName = columnName;
		} else {
			tableSortBy.isDesc = !tableSortBy.isDesc;
		}
		this.setState({ tableSortBy: tableSortBy });
	}

	prepareData() {
		let identity = this.props.identity;
		return this.groupData(this.filterData(this.props.allData[identity.dataSet]));
	}

	prepareLongData() {
		let identity = this.props.identity;
		return this.groupData(this.filterData(this.props.longData[identity.dataSet]));
	}

	filterData(inData) {
		return WorkspaceDataManager.filterData(inData, this.props.identity, this.props.workspaceFilters, this.props.defaultFilters);
	}

	groupData(inData) {
		return WorkspaceDataManager.groupData(inData, this.props.identity, this.props.defaultGroupings, this.props.allMaps, this.props.metricDefs, this.props.allData[this.props.identity.dataSet], this.props.timeFilter);
	}

	getType(kpiIdentifier, dataset) {
		let type;
		if(dataset !== undefined) {
			if(this.props.metricDefs[dataset][window.toCammelCase(kpiIdentifier)] !== undefined) {
				type = this.props.metricDefs[dataset][window.toCammelCase(kpiIdentifier)].formatId;
			}
		}
		return type;
	}

	tableSortData(inData) { }

	generateBarChart() {
		let identity = this.props.identity;

		let outData = this.prepareData().reduce(
			(r, e) => {
				if (r.groupKey === null) {
					r.groupKey = e.groupKey;
				}

				if (!r.xAxis.includes(e.key)) {
					r.xAxis.push(e.key);
				}

				// if (!r.data[e.kpiIdentifier]) {
				// 	r.data[e.kpiIdentifier] = [];
				// }

				if (!r.data[e.columns.name]) {
					r.data[e.columns.name] = []
				}

				if(!r.dataType[e.columns.name]) {
					Object.keys(this.props.metricDefs[this.props.identity.dataSet]).forEach(el => {
						if(e.columns.name === this.props.metricDefs[this.props.identity.dataSet][el].friendlyName) {
							r.dataType[e.columns.name] = this.props.metricDefs[this.props.identity.dataSet][el].formatId;
						}
					})
				}

				// Until we can pull data for more ranges faster, we're gonna only use custom range
				//r.data[e.kpiIdentifier].push(e.cyCustom);
				r.data[e.columns.name].push(e.cyCustom);

				return r;
			},
			{ xAxis: [], data: {}, dataType:{}, groupKey: null }
		);

		//window.xAxis = outData.xAxis;
		//window.barIdentity = identity;

		for (var i = 0; i < outData.xAxis.length; i++) {
			outData.xAxis[i] = toFriendlyName(identity.dataSet, outData.groupKey, outData.xAxis[i]);
		}

		// if (identity.groupables.length === 0 && identity.dataSet === "blast") {
		// 	for (let i = 0; i < outData.xAxis.length; i++) {
		// 		outData.xAxis[i] = generateNameFromID(outData.xAxis[i], "blast");
		// 	}
		// }

		//window.xAxisAfterNameConversion = outData.xAxis;

		return (
			<div className={"content-outer" + (this.props.fullscreenId === identity.id ? " zoom-content" : "")}>
				{this.chartHelper.generateBarChart(outData)}
			</div>
		);
	}

	generateLineChart() {
		let identity = this.props.identity;

		let groupKey = null;
		let metric = undefined;
		let dataType = '';
		let finalData;
		let outData = Object.values(this.prepareLongData().reduce((r, e) => {

			if (groupKey === null) {
				groupKey = e.groupKey;
			}
			if( metric === undefined) {
				metric = e.columns.name;
			}

			let key = e.key;
			if (!r[key]) {
				r[key] = {
					data: [],
					type: "line",
					name: toFriendlyName(identity.dataSet, groupKey, key),
					smooth: true
				}
			}
			r[key].data.push([moment(e.dateIndex + "").format("YYYY-MM-DD"), e.cyCustom])

			return r;
		}, {}));
		if(identity.selectedMetrics.length > 0) {
			Object.keys(this.props.metricDefs[identity.dataSet]).forEach(el => {
				if(metric === this.props.metricDefs[this.props.identity.dataSet][el].friendlyName) {
					dataType = this.props.metricDefs[this.props.identity.dataSet][el].formatId;
				}
			})
			finalData = {
				data: outData,
				dataType: dataType
			}
		}

		return (
			<div className={"content-outer" + (this.props.fullscreenId === identity.id ? " zoom-content" : "")}>
				{this.chartHelper.generateLineChart(finalData)}
			</div>
		);
	}

	generatePieChart() {

		let identity = this.props.identity;
		let metric = undefined;
		let dataType = '';
		let finalData;

		let outData = this.prepareData().reduce(
			(r, e) => {
				if (r.groupKey === null) {
					r.groupKey = e.groupKey;
				}

				if(metric === undefined) {
					metric = e.columns.name;
				}

				if (!r.legend.includes(e.key)) {
					// if (identity.groupables.length === 0 || identity.groupables.includes("StoreId")) {
					// 	r.legend.push(generateNameFromID(e.key, "blast"));
					// } else {
					r.legend.push(e.key);
					// }
				}

				// if (!r.data[e.kpiIdentifier]) {
				// 	r.data[e.kpiIdentifier] = [];
				// }

				if (!r.data[e.columns.name]) {
					r.data[e.columns.name] = []
				}

				// r.data[e.kpiIdentifier].push(e.cyCustom);
				r.data[e.columns.name].push(e.cyCustom);
				return r;
			},
			{ legend: [], data: {}, groupKey: null }
		);

		for (var i = 0; i < outData.legend.length; i++) {
			outData.legend[i] = toFriendlyName(identity.dataSet, outData.groupKey, outData.legend[i]);
		}

		outData.data = Object.values(outData.data);

		if(identity.selectedMetrics.length > 0) {
			Object.keys(this.props.metricDefs[identity.dataSet]).forEach(el => {
				if(metric === this.props.metricDefs[this.props.identity.dataSet][el].friendlyName) {
					dataType = this.props.metricDefs[this.props.identity.dataSet][el].formatId;
				}
			})
			finalData = {
				data: outData,
				dataType: dataType
			}
		}

		//window.pieIdentity = identity;
		//window.pieOutData = outData;

		return (
			<div className={"content-outer" + (this.props.fullscreenId === identity.id ? " zoom-content" : "")}>
				{this.chartHelper.generatePieChart(finalData)}
			</div>
		);
	}

	generateStackedBarChart() {
		let identity = this.props.identity;

		let outData = this.prepareData().reduce(
			(r, e) => {
				if (r.groupKey === null) {
					r.groupKey = e.groupKey;
				}

				if (!r.xAxis.includes(e.key)) {
					r.xAxis.push(e.key);
				}

				// if (!r.data[e.kpiIdentifier]) {
				// 	r.data[e.kpiIdentifier] = [];
				// }

				if (!r.data[e.columns.name]) {
					r.data[e.columns.name] = []
				}

				if(!r.dataType[e.columns.name]) {
					Object.keys(this.props.metricDefs[this.props.identity.dataSet]).forEach(el => {
						if(e.columns.name === this.props.metricDefs[this.props.identity.dataSet][el].friendlyName) {
							r.dataType[e.columns.name] = this.props.metricDefs[this.props.identity.dataSet][el].formatId;
						}
					})
				}

				// Until we can pull data for more ranges faster, we're gonna only use custom range
				//r.data[e.kpiIdentifier].push(e.cyCustom);
				r.data[e.columns.name].push(e.cyCustom);

				return r;
			},
			{ xAxis: [], data: {}, dataType: {}, groupKey: null }
		);

		for (var i = 0; i < outData.xAxis.length; i++) {
			outData.xAxis[i] = toFriendlyName(identity.dataSet, outData.groupKey, outData.xAxis[i]);
		}
		return <div className={"content-outer" + (this.props.fullscreenId === identity.id ? " zoom-content" : "")}>
			{this.chartHelper.generateStackedBarChart(outData)}
		</div>;
	}

	generateCardChart() {
		let outData = this.prepareData();
		let cardData = outData.reduce(
			(r, e) => {
				if (r.type === "") {
					r.type = e.columns.type;
				}
				if (r.isAvg === "") {
					r.isAvg = e.columns.isAvg;
				}	
				if (r.kpiIdentifier === "") {
					r.kpiIdentifier = e.kpiIdentifier;
				}			
				
				r.cySum += e.cyCustom;
				r.lySum += e.lyCustom;
				
				return r;
			},
			{ cySum: 0, lySum: 0, type: "", kpiIdentifier: "", isAvg: "" }
		);	
		
		if (jackDebug.cardData === undefined) { jackDebug.cardData = {} }
		jackDebug.cardData[this.props.identity.id] = cardData;
			
		if(this.props.isAABIDash && (cardData.isAvg === 'True' || cardData.kpiIdentifier.slice(0, 10) === 'CompanyAvg'))
		{
			cardData.cySum = (cardData.cySum / outData.length);
			cardData.lySum = (cardData.lySum / outData.length);
		};

		let pctYoY = Math.abs((cardData.lySum - cardData.cySum) / cardData.lySum);
		if(isNaN(pctYoY) || !isFinite(pctYoY) || pctYoY === null) {
			pctYoY = 0;
		}
		//let increaseDecrease = cardData.cySum >= cardData.lySum ? "+" : "-";
		let isNegative = false;
		if(this.props.metricDefs != undefined && cardData != undefined) {
			if(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(cardData.kpiIdentifier)] !== undefined) {
				isNegative = JSON.parse(this.props.metricDefs[this.props.identity.dataSet][window.toCammelCase(cardData.kpiIdentifier)].isNegative.toLowerCase());
			}
		}
		let formatId = this.getType(cardData.kpiIdentifier, this.props.identity.dataSet);
		let type = formatId !== undefined ? formatId : cardData.type
		let prefix = type === 'DEC' || type === 'MNY' ? '$' : '';
		let suffix = type === 'PCT' ? '%' : '';
		let text = cardData.cySum;
		text = commaFormat(['DEC', 'PCT', 'DC2'].includes(type) ? text.toFixed(2) : ['DC1'].includes(type) ? text.toFixed(1) : text.toFixed(0));
		return (
			<div className={"content-outer"}>
				<div
					className={"chart-card-content" + (this.props.fullscreenId === this.props.identity.id ? " zoom-text" : "")}
					style={
						isNegative ? cardData.cySum > cardData.lySum ?  { color: "#BD3845" } : cardData.cySum < cardData.lySum ? { color: "#007A3F" } : { color: "" } : cardData.cySum > cardData.lySum ? { color: "#007A3F" } : cardData.cySum < cardData.lySum ? { color: "#BD3845" } : { color: "" }
					}
				>
					{prefix + text + suffix}
				</div>
				<div className={"chart-card-yoy" + (this.props.fullscreenId === this.props.identity.id ? " zoom-text" : "")}>
					{pctYoY !== Infinity
						? (100 * pctYoY).toFixed(2) + "% YoY"
						: ""}
				</div>
			</div>
		);
	}

	generateTable() {

		let identity = this.props.identity;

		// if (jackDebug.identityForTable === undefined) { jackDebug.identityForTable = {} }
		// jackDebug.identityForTable = identity;

		//window.testDaData = this.prepareData();

		let tableData = this.prepareData().reduce((r, e) => {

			let rowKey = e.key;

			if (!r.data[rowKey]) {
				r.data[rowKey] = {
					info: {},
					kpi: {}
				};

				identity.supportFields.forEach((field) => {
					field = field.substring(0, 1).toLowerCase() + field.substring(1);
					r.data[rowKey].info[field] = e.columns[field];
				});
			}
			if (!r.data[rowKey].kpi[e.kpiIdentifier]) {
				r.data[rowKey].kpi[e.kpiIdentifier] = {
					kpiIdentifier: e.kpiIdentifier,
					cyValue: e.cyCustom,
					lyValue: e.lyCustom
				}
			}
			if (!r.metaData[e.kpiIdentifier]) {
				r.metaData[e.kpiIdentifier] = {
					isAvg: e.columns.isAvg,
					prec: e.columns.prec,
					sign: e.columns.sign,
					type: e.columns.type
				}
			}

			return r;
		}, { data: {}, metaData: {} });

		if (!jackDebug.tableData) { jackDebug.tableData = {} }

		jackDebug.tableData = tableData;

		let tableValueData = Object.values(tableData.data)

		let colName = this.state.tableSortBy.columnName;

		let sortCol = this.state.tableSortBy.columnName;
		if (colName != null) {
			colName = colName.charAt(0).toUpperCase() + colName.slice(1);
		}

		if (colName != null && tableValueData.length > 1 &&
			(identity.supportFields.includes(colName) || identity.selectedMetrics.some(x => x.metric === colName))) {
			if (identity.supportFields.includes(colName)) {
				try {

					if (this.state.tableSortBy.columnName === 'storeId') {
						tableValueData = _.sortBy(tableValueData, (dat) => {
							let res = generateNameFromID(dat.info[toCammelCase(sortCol)], 'BLAST').toString().toUpperCase().match(/[a-zA-Z0-9]+/g);
							return res.join(' ');
						});
					} else if(this.state.tableSortBy.columnName === 'brandId') {
						tableValueData = _.sortBy(tableValueData, (dat) => {
							let res = generateNameFromID(dat.info[toCammelCase(sortCol)], 'Brand').toString().toUpperCase().match(/[a-zA-Z0-9]+/g);
							return res.join(' ');
						});
					}
					else {
						tableValueData = _.sortBy(tableValueData, (dat) => {
							let res = dat.info[toCammelCase(sortCol)].toString().toUpperCase().match(/[a-zA-Z0-9]+/g);
							return res.join(' ');
						});
					}
				}
				catch (err) {
					console.log(err);
					tableValueData = tableValueData;
				}

			} else if (identity.selectedMetrics.some(x => x.metric === colName)) {
				tableValueData = _.sortBy(tableValueData, (dat) =>
					dat.kpi[colName].cyValue
				);
			}

			if (this.state.tableSortBy.isDesc) {
				tableValueData.reverse();
			}
		}

		//handle default ordering of columns
		let orderedMetaData = {};
		let arrToSort = [];
		for (var metric in this.props.defaultKpiOrder[identity.dataSet]) {
			arrToSort.push([[metric], this.props.defaultKpiOrder[identity.dataSet][metric]])
		}
		//window.arrToSort = arrToSort;
		arrToSort.sort((a, b) => { return a[1] - b[1] });
		arrToSort.forEach(obj => {
			// let metricName = obj[0].toString().charAt(0).toUpperCase() + obj[0].toString().slice(1);
			// if (tableData.metaData.hasOwnProperty(metricName)) {
			// 	orderedMetaData[metricName] = tableData.metaData[metricName];
			// }
			for (var originalMet in tableData.metaData) {
				if (originalMet.toString().toLowerCase() === obj[0].toString().toLowerCase()) {
					orderedMetaData[originalMet] = tableData.metaData[originalMet];
				}
			}
		});
		//window.tableDataBefore = tableData.metaData;
		tableData.metaData = orderedMetaData;
		//window.tableDataAfter = tableData.metaData;
		
		return (
			<div className={"content-outer" + (this.props.fullscreenId === identity.id ? " zoom-content" : "")}>
				<WorkspaceTableChart
					identity={identity}
					data={tableValueData}
					metaData={tableData.metaData}
					tableSortBy={this.state.tableSortBy}
					setTableSortBy={this.setTableSortBy}
					isAABIDash={this.props.isAABIDash}
					metricDefs={this.props.metricDefs}
				/>
			</div>
		);
	}

	generateContent() {
		let identity = this.props.identity;

		switch (identity.chartType) {
			case "bar":
				return this.generateBarChart();
			case "line":
				return this.generateLineChart();
			case "pie":
				return this.generatePieChart();
			case "stackedBar":
				return this.generateStackedBarChart();
			case "card":
				return this.generateCardChart();
			case "table":
				return this.generateTable();
			default:
				return null;
		}
	}

	generateDesignFeatures() {
		let identity = this.props.identity;

		let canShrinkX = this.props.canShrinkX;
		let canShrinkY = this.props.canShrinkY;
		return (
			<div className={"design-features-outer"}>
				<div className={"stretcher top vert" + (!this.props.canStretchUp && !canShrinkY ? " hidden" : "")}>
					<div className={"material-icons stretcher-button top" + (!this.props.canStretchUp ? " disabled" : "")} onClick={this.props.stretchUp}>
						{"arrow_forward_ios"}
					</div>
					<div
						className={
							"material-icons stretcher-button bottom" +
							(!canShrinkY ? " disabled" : "")
						}
						onClick={this.props.shrinkDown}
					>
						{"arrow_forward_ios"}
					</div>
				</div>
				<div
					className={
						"stretcher right horiz" +
						(!canShrinkX && !this.props.canStretchRight
							? " hidden"
							: "")
					}
				>
					<div
						className={
							"material-icons stretcher-button left" +
							(!canShrinkX ? " disabled" : "")
						}
						onClick={this.props.shrinkLeft}
					>
						{"arrow_forward_ios"}
					</div>
					<div
						className={
							"material-icons stretcher-button right" +
							(!this.props.canStretchRight ? " disabled" : "")
						}
						onClick={this.props.stretchRight}
					>
						{"arrow_forward_ios"}
					</div>
				</div>
				<div
					className={
						"stretcher bottom vert" +
						(!canShrinkY && !this.props.canStretchDown
							? " hidden"
							: "")
					}
				>
					<div
						className={
							"material-icons stretcher-button top" +
							(!canShrinkY ? " disabled" : "")
						}
						onClick={this.props.shrinkUp}
					>
						{"arrow_forward_ios"}
					</div>
					<div
						className={
							"material-icons stretcher-button bottom" +
							(!this.props.canStretchDown ? " disabled" : "")
						}
						onClick={this.props.stretchDown}
					>
						{"arrow_forward_ios"}
					</div>
				</div>
				<div className={"stretcher left horiz" + (!this.props.canStretchLeft && !canShrinkX ? " hidden" : "")}>
					<div
						className={
							"material-icons stretcher-button left" +
							(!this.props.canStretchLeft ? " disabled" : "")
						}
						onClick={this.props.stretchLeft}
					>
						{"arrow_forward_ios"}
					</div>
					<div
						className={
							"material-icons stretcher-button right" +
							(!canShrinkX ? " disabled" : "")
						}
						onClick={this.props.shrinkRight}
					>
						{"arrow_forward_ios"}
					</div>
				</div>
				<div className={"mover"}>
					<div className={"material-icons mover-filler"}>{"open_with"}</div>
					<div
						className={"mover-button top" + (!this.props.canStretchUp ? " disabled" : "")}
						onClick={this.props.moveUp}
					><div className={"material-icons mover-button-icon"}>{"arrow_upward"}</div></div>
					<div
						className={"mover-button right" + (!this.props.canStretchRight ? " disabled" : "")}
						onClick={this.props.moveRight}
					><div className={"material-icons mover-button-icon"}>{"arrow_forward"}</div></div>
					<div
						className={"mover-button bottom" + (!this.props.canStretchDown ? " disabled" : "")}
						onClick={this.props.moveDown}
					><div className={"material-icons mover-button-icon"}>{"arrow_downward"}</div></div>
					<div
						className={"mover-button left" + (!this.props.canStretchLeft ? " disabled" : "")}
						onClick={this.props.moveLeft}
					><div className={"material-icons mover-button-icon"}>{"arrow_back"}</div></div>
				</div>
			</div>
		);
	}

	generateMenu() {
		let identity = this.props.identity;

		let menuOptions = []

		if (this.props.isDesignMode) {

			menuOptions.push((
				<div data-trackid={'chart-menu-edit'} className={"option"} onClick={this.props.openEditCardModal.bind(null, identity)}>{"Edit"}</div>
			))

			menuOptions.push((
				<div data-trackid={'chart-menu-delete'}
					className={"option"}
					onClick={() => {
						zconfirm(
							"Are you sure you want to delete this visual? (This cannot be undone unless you restore it from the last published Dashboard.)",
							this.props.deleteVisual.bind(null, identity.id)
						);
					}}
				>
					{"Delete"}
				</div>
			));
		} else {
			if (this.props.fullscreenId === identity.id) {
				menuOptions.push((
					<div data-trackid={'chart-menu-close-fullscreen'} className={"option"} onClick={this.props.closeFullscreen}>{"Close"}</div>
				))
			}
			else {
				menuOptions.push((
					<div data-trackid={'chart-menu-open-fullscreen'} className={"option"} onClick={this.props.openFullscreen.bind(null, identity)}>{"Full Screen"}</div>
				))
			}
			menuOptions.push((
				<div data-trackid={'chart-menu-export'} className={"option"} onClick={this.props.openModal.bind(null, "export")}>{"Export"}</div>
			))
			menuOptions.push((
				<div data-trackid={'chart-menu-dictionary'} className={"option"} onClick={this.props.metricDefinitions.bind(null, "metricDefinitions", identity)}>{"Metric Dictionary"}</div>
			))
			menuOptions.push((
				<div data-trackid={'chart-menu-lock-chart'} className={"option toggle-option"}>
					<div className={"toggle-caption"}>{"Lock Chart"}</div>
					<input className={"toggle"} checked={this.props.identity.isLocked} type="checkbox"/><label className={"toggle-label"} onClick={() => this.toggleLock()}>Toggle</label>
				</div>
			))
			if (this.props.identity.chartType === 'bar' || this.props.identity.chartType === 'stackedBar') {
				let toggle = this.props.identity.initialChartType !== undefined ? this.props.identity.initialChartType === "bar" ? "Stacked Bar" : "Clustered Bar" : this.props.identity.chartType === "bar" ? "Stacked Bar" : "Clustered Bar";
				let toggleCheck = this.props.identity.initialChartType !== undefined ? this.props.identity.initialChartType !== this.props.identity.chartType : false;
				menuOptions.push((
					<div data-trackid={'chart-menu-toggle-bar'} className={"option toggle-option"}>
						<div className={"toggle-caption"}>{toggle}</div>
						<input className={"toggle"} checked={toggleCheck} type="checkbox"/><label className={"toggle-label"} onClick={() => this.toggleChart(this.props.identity.chartType)}>Toggle</label>
					</div>	
				))
			}
		}

		return (
			<div className={"menu-button-outer" + (this.props.fullscreenId === identity.id ? " zoom-text" : "")}>
				<div
					className={"material-icons menu-button" + (this.props.fullscreenId === identity.id ? " zoom-text" : "")}
					onClick={this.props.openMenu.bind(null, identity.id)}
				>
					{"more_vert"}
				</div>
				<div
					className={"menu-blocker" + (this.props.menuOpen ? "" : " hidden")}
					onClick={this.props.closeMenu}
				></div>
				<div className={"menu-outer" + (this.props.menuOpen ? "" : " hidden") + (this.props.isDesignMode ? " short-edit" : this.props.identity.chartType === 'bar' || this.props.identity.chartType === "stackedBar" ? " medium" : " short")}>
					{menuOptions}
				</div>
			</div>
		)
	}

	toggleLock() {
		let card = {
			...this.props.identity,
			isLocked: !this.props.identity.isLocked
		}
		this.props.toggleLock(card);
	}

	toggleChart(chartType) {
		let updatedChartType = chartType === 'bar' ? 'stackedBar' : 'bar';
		let card;
		if(this.props.identity.initialChartType === undefined) {
			card = {
				...this.props.identity,
				chartType: updatedChartType,
				initialChartType: chartType
			}
		} else {
			card = {
				...this.props.identity,
				chartType: updatedChartType
			}
		}	
		this.props.toggleChart(card);
	}

	render() {
		let identity = this.props.identity,
			columns = this.props.columns,
			x = this.props.x,
			y = this.props.y;

		let cardStyle = {
			top: y * 19.5 + "rem",
			left: `calc((100% - ${(columns - 1) * 2.5}rem) / ${columns} * ${x} + ${x * 2.5}rem)`,
			width: `calc((100% - ${(columns - 1) * 2.5}rem) / ${columns} * ${identity.width} + ${(identity.width - 1) * 2.5}rem)`,
			height: 17 + (identity.height - 1) * 19.5 + "rem",
		};

		if (this.props.fullscreenId === identity.id) {
			// position: fixed;
			// top: 50%;
			// left: calc(50% + 12.225rem);
			// transform: translate(-50%, -50%);
			// z-index: 999;

			//let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

			//let bdWidth = document.body.clientWidth - rem * 24.45;
			//let bdHeight = document.body.clientHeight - rem * 5.5;
			//let visWidth = (document.body.clientWidth - (columns - 1) * 2.5 * rem) / columns * identity.width + (identity.width - 1) * 2.5 * rem;
			// let visWidth = document.getElementById(`visualization-card-id-${identity.id}`).clientWidth;
			//let visHeight = document.getElementById(`visualization-card-id-${identity.id}`).clientHeight;

			//let ratio = ([bdWidth / visWidth, bdHeight / visHeight].sort()[0] * 0.95).toFixed(4)

			cardStyle.position = "fixed";
			cardStyle.top = "8rem";
			cardStyle.left = "6.1rem";
			cardStyle.width = "calc(100% - 8.6rem)";
			cardStyle.height = "calc(100% - 13rem)";
			cardStyle.zIndex = "999";
		}
		let isDataLoaded = identity.chartType === 'line' ? this.props.longData[identity.dataSet].length : this.props.allData[identity.dataSet].length;
		if(this.state.isLoading || isDataLoaded === 0) {
			let loadingCardStyle = {
				width: '100%',
				height: '100%',
				opacity: '0.2',
			}
			return (
				<div id="visual-loader" style={cardStyle} className={"loading-overlay--active"}>
					<div
					key={`visualization-card-id-${identity.id}`}
					id={`visualization-card-id-${identity.id}`}
					className={"visualization-card-outer"}
					style={loadingCardStyle}
					tabIndex={-1}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
				>
					<div className={"top-bar"}>
						<div className={"title" + (this.props.fullscreenId === identity.id ? " zoom-text" : "")}>{identity.title}</div>
						<div className={this.props.identity.isLocked ? 'material-icons' : 'dispNone'}>{'lock'}</div>
						{this.generateMenu()}
					</div>
					{this.generateContent()}
					{this.generateDesignFeatures()}
				</div>
                    <div className={this.state.isLoading ? 'bounce1 bounce' : 'dispNone'}></div>
                    <div className={this.state.isLoading ? 'bounce2 bounce' : 'dispNone'}></div>
                    <div className={this.state.isLoading ? 'bounce' : 'dispNone'}></div>
					<div className={this.state.isLoading ? 'dispNone' : ''}>Metrics Data for Selected Date Range Not Found.</div>
                </div>
			)
		} else {
			return (
				<div
					key={`visualization-card-id-${identity.id}`}
					id={`visualization-card-id-${identity.id}`}
					className={"visualization-card-outer"}
					style={cardStyle}
					tabIndex={-1}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
				>
					<div className={"top-bar"}>
						<div className={"title" + (this.props.fullscreenId === identity.id ? " zoom-text" : "")}>{identity.title}</div>
						<div className={this.props.identity.isLocked ? 'material-icons' : 'dispNone'}>{'lock'}</div>
						{this.generateMenu()}
					</div>
					{this.generateContent()}
					{this.generateDesignFeatures()}
				</div>
			);
		}	
	}
}